<template>
    <b-form-group
      :label="setLabel()"
      label-for="grupo"
      label-class="font_size_label"
    >
      <validation-provider #default="{ errors }" name="Grupo" :rules="rules">
        <v-select
          id="grupo"
          :options="options"
          v-model="selected"
          :placeholder="placeholder"
          label="descricao"
          :clearable="true"
          :multiselect="ehMultiplo"
          :multiple="ehMultiplo"
          :disabled="loading"
          @input="checkMaxSelection"
        >
          <template #list-header v-if="ehMultiplo && options.length > 0">
            <div class="vs__dropdown-option" @click="toggleSelectAll">
              <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
              <span>Selecionar Todos</span>
            </div>
          </template>
          <span slot="no-options">Nenhuma opção selecionável.</span>
        </v-select>
        <small v-if="errors[0]" class="text-danger">
          {{ errors[0] }}
        </small>
      </validation-provider>
    </b-form-group>
  </template>

  <script>
  import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
  } from "bootstrap-vue";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import vSelect from "vue-select";

  import {getUserData} from "@/auth/utils";
  import { TIPO_RELATORIO_ENUM } from "../config";

  export default {
    components: {
      BForm,
      BCol,
      BRow,
      BFormGroup,
      BFormInput,
      BButton,
      BTable,
      BSpinner,
      BFormDatepicker,
      BFormTextarea,
      BOverlay,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    props: {
      value: {
        required: true,
      },
      optionsConsulted: {
        required: false,
        type: Array,
        default: () => [],
      },
      idTipoRelatorio: {
        required: true,
        type: Number
      }
    },
    data() {
      return {
        options: [],
        userData: getUserData(),
        selected: this.value,
        placeholder: "Carregando...",
        loading: true,
        ehMultiplo: true,
        rules: "",
        relatoriosComLimitacao: [
          TIPO_RELATORIO_ENUM.ADESAO_POR_EMPRESAS_CAMPANHA_ESTADUAL_ID,
          TIPO_RELATORIO_ENUM.COLABORADORES_VACINADOS_ID,
          TIPO_RELATORIO_ENUM.QUANTITATIVO_VACINACAO_ID,
        ],
        relatorioNaoMultiplo: [
          TIPO_RELATORIO_ENUM.COLABORADORES_CADASTRADOS_ID,
        ],
        temLimiteSelecao: false,
      };
    },
    beforeMount() {
      this.setOptions();
      this.setRules();
    },
    methods: {
      async setOptions() {
        if (this.optionsConsulted.length > 0) {
          this.options = this.optionsConsulted;
          return;
        }

        await this.$http
          .get(this.$api.getGruposCampanhaNacional())
          .then(({ data }) => {
            this.options = data.map((grupo) => {
              return {
                id_empresa: grupo.id_grupo,
                descricao: grupo.descricao,
              };
            });
          });
      },
      checkMaxSelection() {
        if (this.temLimiteSelecao && this.selected.length > 5) {
          this.selected.pop();
        }
      },
      setRules() {
        this.temLimiteSelecao = this.relatoriosComLimitacao.includes(this.idTipoRelatorio)
        if (this.temLimiteSelecao) {
          this.rules = "required"
        }

        if (this.relatorioNaoMultiplo.includes(this.idTipoRelatorio)) {
          this.ehMultiplo = false
        }
      },
      setLabel() {
        let label = 'Grupos';
        if(this.temLimiteSelecao){
          label = 'Grupo (Selecione no máx 5)*'
        }

        if(!this.ehMultiplo){
          label = 'Grupo'
        }

        return label
      },
      toggleSelectAll() {
        if (this.isAllSelected) {
          this.selected = [];
        } else {
          this.selected = [...this.options];
        }
      }
    },
    computed: {
      isAllSelected() {
        return this.selected && this.selected.length === this.options.length;
      }
    },
    watch: {
      selected: function (valor) {
        if(!this.ehMultiplo && valor){
          valor = [{
          id_grupo: valor.id_empresa,
          descricao: valor.descricao
          }];
        }
        this.$emit("selected", valor);
      },
      options: function (valor) {
        this.loading = this.options.length == 0;
        this.placeholder = this.loading
          ? "Nenhum registro encontrado"
          : "Selecione o grupo";

        this.$emit("options", valor);
      },
    },
  };
  </script>
